<template>
  <v-container>
    <v-flex>
      <v-card class="elevation-1">
        <v-toolbar color="primary">
          <v-toolbar-title class="white--text">Sales report</v-toolbar-title>
        </v-toolbar>
        <v-flex>
          <v-card-title>
            <v-flex xs12 lg1 class="pt-3 pl-3" v-if="meProps.is_provider">
              <v-select
                v-bind:items="accountType"
                v-model="accountTypeSelected"
                label="Type"
                item-text="account"
                item-value="accountValue"
                bottom
              ></v-select>
            </v-flex>
            <v-flex xs12 lg1 class="pt-3 pl-3">
              <v-select
                v-bind:items="country"
                v-model="countrySelected"
                label="Country"
                item-text="country"
                item-value="countryValue"
                bottom
              ></v-select>
            </v-flex>
            <v-flex xs12 lg2 class="pt-3 pl-3" v-if="meProps.is_provider">
              <v-select
                :items="agencies"
                  v-model="selectedAgency"
                  label="Agencies"
                  item-text="company"
                  item-value="id"
                  bottom
                  autocomplete
              >
                <template slot="item" slot-scope="data">
                  <template>
                    <v-list-tile-content>
                      <v-list-tile-title>{{data.item.company}} {{data.item.id}}</v-list-tile-title>
                    </v-list-tile-content>
                  </template>
                </template>
              </v-select>
            </v-flex>
            <v-flex xs12 lg1 class="pt-3 pl-3">
              <v-select
                v-bind:items="typeItems"
                v-model="typeSelected"
                item-text="name"
                item-value="value"
                label="Status"
                bottom
              ></v-select>
            </v-flex>
            <v-flex xs12 lg2 class="pt-3 pl-3">
              <v-menu
                  lazy
                  :close-on-content-click="false"
                  v-model="menuFrom"
                  transition="scale-transition"
                  offset-y
                  full-width
                  :nudge-right="40"
                  max-width="290px"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    label="Date from:"
                    v-model="dateFrom"
                    prepend-icon="event"
                  ></v-text-field>
                  <v-date-picker v-model="dateFrom" no-title scrollable actions>
                    <template slot-scope="{ save, cancel }">
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="cancel">Cancel</v-btn>
                        <v-btn flat color="primary" @click="save">OK</v-btn>
                      </v-card-actions>
                    </template>
                  </v-date-picker>
                </v-menu>
            </v-flex>
            <v-flex xs12 lg2 class="pt-3 pl-3">
              <v-menu
                lazy
                :close-on-content-click="false"
                v-model="menuTo"
                transition="scale-transition"
                offset-y
                full-width
                :nudge-right="40"
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  label="Date to:"
                  v-model="dateTo"
                  prepend-icon="event"
                ></v-text-field>
                <v-date-picker v-model="dateTo" no-title scrollable actions>
                  <template slot-scope="{ save, cancel }">
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="cancel">Cancel</v-btn>
                      <v-btn flat color="primary" @click="save">OK</v-btn>
                    </v-card-actions>
                  </template>
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 lg1 class="pl-5">
              <v-btn
                color="primary"
                @click="searchFilter"
                dark
                right
                block
              > Search
              </v-btn>
            </v-flex>
              
          </v-card-title>
          <v-data-table
              v-bind:headers="headers"
              v-bind:items="items"
              v-bind:search="search"
              v-bind:rows-per-page-items="rows"
              :loading="loading"
              hide-actions
            >
            <template slot="items" slot-scope="props">
              <td class="text-xs-center">{{ props.index+1 }}</td>
              <td class="text-xs-center" v-if="meProps.is_provider">{{ props.item.is_provider | isProvider}}</td>
              <td class="text-xs-center" v-if="meProps.is_provider">{{ props.item.company }}</td>
              <td class="text-xs-center">{{ props.item.created_at | removeTime }}</td>
              <td class="text-xs-center">{{ props.item.insurance_type }}</td>
              <td class="text-xs-center">{{ props.item.policy_uuid }}</td>
              <td class="text-xs-center">{{ props.item.people_count }}</td>
              <td class="text-xs-center">{{ props.item.cancelled | status }}</td>
              <td class="text-xs-center green--text">$ {{ props.item.amount | minusRemover}}</td>
              <td class="text-xs-center">{{ props.item.first_name }} {{ props.item.last_name }}</td>
            </template>
            <template slot="footer">
              <td class="text-xs-center">
                <strong>
                  Total:
                </strong>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td v-if="meProps.is_provider"></td>
              <td v-if="meProps.is_provider"></td>
              <td class="text-xs-center green--text">
                <strong>
                  $ {{ sum }}
                </strong>
              </td>
              <td></td>
            </template>
          </v-data-table>
        </v-flex>
      </v-card>
    </v-flex>
  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment"
export default {
  data() {
    return {
      loading: true,
      rows: [10, 15, 25, { text: "All", value: -1 }],
      search: "",
      pagination: {},
      counter: 0,
      dateFrom: moment().subtract(1, 'month').format("YYYY-MM-DD"),
      menuFrom: null,
      dateTo: null,
      menuTo: null,
      sum: null,
      agencies: [{company: 'All', id : null}],
      selectedAgency: null,
      typeSelected: null,
      typeItems: [
          { name: 'All', value: null },
          { name: 'Booked', value: 'false' },
          { name: 'Cancelled', value: 'true' }
        ],
      countrySelected: null,
      country: [
          { country: 'All', countryValue: null },
          { country: 'Turkey', countryValue: 'turkey' },
          { country: 'Other', countryValue: 'other' }
        ],
      accountTypeSelected: null,
      accountType: [
          { account: 'All', accountValue: null },
          { account: 'Agency', accountValue: 'agency' },
          { account: 'Provider', accountValue: 'provider' }
        ],
      searchQuery: '',
      headers: [
        {
          text: "No.",
          align: "center",
          sortable: false,
          value: "id"
        },
        { text: "Account Type", value: "accountType", sortable: false, align: "cetner" },
        {
          text: "Agency",
          value: "agency",
          sortable: false,
          align: "center"
        },
        { text: "Date", value: "date", sortable: false, align: "center" },
        {
          text: "Type of Insurance",
          value: "insuranceType",
          sortable: false,
          align: "center"
        },
        {
          text: "Insurance ID",
          value: "policy_uuid",
          sortable: false,
          align: "center"
        },
        {
          text: "Num. of people",
          value: "number_of_people",
          sortable: false,
          align: "center"
        },
        {
          text: "Status",
          value: "status",
          sortable: false,
          align: "center"
        },
        {
          text: "Total",
          value: "total",
          sortable: false,
          align: "center"
        },
        {
          text: "Beneficiary",
          value: "user",
          sortable: false,
          align: "center"
        }
      ],
      items: [],
      meProps: {}
    };
  },
  filters: {
    isProvider: function(value) {
      if (value == '0') {
        value = "Agency";
      } else {
        value = "Provider";
      }
      return value;
    },
    status: function(value) {
      if (value == '0') {
        value = "Booked";
      } else {
        value = "Cancelled";
      }
      return value;
    },
    minusRemover: function(value) {
      return value.replace('-', '');
    },
    removeTime: function(value) {
      return value.substring(0, value.length - 9);
    }
  },
  mounted() {
      this.searchFilter()
      axios.get('/me')
        .then(res => {
          this.meProps = res.data;
          if (!this.meProps.is_provider) {
            this.headers = [
        {
          text: "No.",
          align: "center",
          sortable: false,
          value: "id"
        },
        { text: "Date", value: "date", sortable: false, align: "center" },
        {
          text: "Type of Insurance",
          value: "insuranceType",
          sortable: false,
          align: "center"
        },
        {
          text: "Insurance ID",
          value: "policy_uuid",
          sortable: false,
          align: "center"
        },
        {
          text: "Num. of people",
          value: "number_of_people",
          sortable: false,
          align: "center"
        },
        {
          text: "Status",
          value: "status",
          sortable: false,
          align: "center"
        },
        {
          text: "Total",
          value: "total",
          sortable: false,
          align: "center"
        },
        {
          text: "Beneficiary",
          value: "user",
          sortable: false,
          align: "center"
        }
      ]
          }
          this.dataLoading = !this.dataLoading
        })
       if (this.meProps.is_provider) this.getAgencies();
  },
  methods: {
    calculated() {
      let summary = 0;
      for (var key in this.items) {
        var a = Math.abs(this.items[key].amount);
        summary += a;
      }
      this.sum = summary
    },
    getAgencies(){
        axios
          .get("/agencies")
          .then(res => {
            for (var user in res.data.users) {
              this.agencies.push(res.data.users[user]);
            }
          });
    },
    goToPolicy(id) {
      this.$router.push({ path: `/admin/policies/show/${id}` });
    },
    buildQuery() {
      this.searchQuery = ''
      if (this.selectedAgency){
        this.searchQuery+= 'agency=' + this.selectedAgency + "&";
      }
      if (this.countrySelected){
        this.searchQuery+= 'country=' + this.countrySelected + "&";
      }
      if (this.accountTypeSelected){
        this.searchQuery+= 'account_type=' + this.accountTypeSelected + "&";
      }
      if (this.typeSelected){
        this.searchQuery+= 'cancelled=' + this.typeSelected + "&";
      }
      if (this.dateFrom) {
        this.searchQuery+= 'date_from=' + this.dateFrom + "&";
      }
      if (this.dateTo) {
        this.searchQuery+= 'date_to=' + this.dateTo + "&";
      }
      this.searchQuery = this.searchQuery.slice(0, -1);
    },
    searchFilter() {
      this.buildQuery();
      this.loading = true;
      this.items = [];
      this.sum = 0;
      axios.get("/reports/sales?" + this.searchQuery).then(response => {
        response.data.reports.forEach(element => {
          if (element.tx_type === "SALE" && element.cancelled == "1") { 
            return false;
          } else {
            this.items.push(element)
          }
        });
        this.loading = false;
        this.calculated()
      })
      .catch(function (error) {
            this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/agency/Sales/Sales.vue